module.exports = __webpack_public_path__ + "img/partner2.232b7f45.png";